import { Component } from '@angular/core';
import packageJson from '../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: []
})
export class FooterComponent {
  appVersion = packageJson.version;
}
